module.exports = __webpack_public_path__ + "static/img/pic1.303af13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case2/pic1.jpg
// module id = QGEV
// module chunks = 1